import { Injectable, signal } from '@angular/core';

/**
 * GozemMoneyAccountStore
 *
 * Root-scoped, in-memory store for the primary GozemMoney wallet account ID.
 *
 * Security rationale: this ID authorises financial transactions and must
 * never be persisted to localStorage where an XSS attack could read it.
 * Storing it as a plain Angular signal keeps it in the JS heap only —
 * cleared on page refresh and explicitly wiped on logout.
 *
 * Lifecycle:
 *   Set  → WalletStore after /api/merchant/gozem_money/home loads
 *   Read → TopupApi.basePayload() for every topup request
 *   Clear → AuthService.logout()
 */
@Injectable({ providedIn: 'root' })
export class GozemMoneyAccountStore {
  private readonly _primaryAccountId = signal<string>('');

  /** Primary GozemMoney wallet account ID sourced from the wallet_accounts section */
  readonly primaryAccountId = this._primaryAccountId.asReadonly();

  setPrimaryAccountId(id: string): void {
    this._primaryAccountId.set(id);
  }

  clear(): void {
    this._primaryAccountId.set('');
  }
}
